import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import headstalking from "../../images/film/headstalking.png";

function HeadsTalking() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">

        <div className="text-section">
          <div className="heads-row">
            <div>
                      <div className="text-section">
          <Typography className="title" variant="h6">
            Heads Talking
          </Typography>
          <Typography className="title venue-title" variant="h6">
Sandbar 
          </Typography>
        </div>
              <Typography className="title film-title" variant="h6">
                Other People’s Poetry Presents… THE PSYCHE <span>17:00</span>
              </Typography>
              <Typography className="text">
Abhijeet Singh (host)
              </Typography>
              <Typography className="text">
Sascha Akhtar, Bonnie Hancell & Imogen Cassels
              </Typography>
            </div>

            <img
              src={headstalking}
              className="high-fid-film"
              alt="heads talking"
            />
          </div>
        </div>
        </div>
    </Container>
  );
}
export default HeadsTalking;


